import { render, staticRenderFns } from "./WaitModal.vue?vue&type=template&id=45552d91&scoped=true"
import script from "./WaitModal.vue?vue&type=script&lang=ts"
export * from "./WaitModal.vue?vue&type=script&lang=ts"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45552d91",
  null
  
)

export default component.exports